import { NavigationContainerRefWithCurrent } from '@react-navigation/native'
import React, { createContext, useContext, useEffect, useState } from 'react'

import { links } from 'utils/constants'
import { Toast } from 'utils/toast'

import { Program } from 'types/program'

const FocusModeContext = createContext({
  group: undefined as Program | undefined,
  setGroup: (id: Program | undefined) => {},
})

type FocusModeContextProps = {
  children: React.ReactNode
  drawerNavigationRef: NavigationContainerRefWithCurrent<ReactNavigation.RootParamList>
}

const FocusModeContextProvider = ({ children, drawerNavigationRef }: FocusModeContextProps) => {
  const [group, setGroup] = useState<Program | undefined>(undefined)

  useEffect(() => {
    if (!group) return
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    drawerNavigationRef?.navigate(links.MAIN_TABS, {
      screen: links.HOME_STACK,
      params: {
        screen: links.FEED_PAGE,
      },
    })
    Toast.warn(
      `Welcome`,
      `You've entered Focus Mode. All tabs are filtered for this Group.`,
      undefined,
      {},
      true,
      'bottom',
      undefined,
      undefined,
      true,
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [group])

  return (
    <FocusModeContext.Provider value={{ group, setGroup }}>{children}</FocusModeContext.Provider>
  )
}

const useFocusMode = () => {
  const focusMode = useContext(FocusModeContext)
  if (focusMode == null) {
    throw new Error('useFocusMode() called outside of a FocusModeContextProvider?')
  }

  return focusMode
}

export { FocusModeContextProvider, useFocusMode }
